// Task.js
import { Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDrag } from "react-dnd";
import NewAvailability from "../../view/availability/insert-availability";
import SmallCard from "../card-funil/card-funil-small/card-small";
import ResponsiveDialog from "../dialog/dialog";
import "./tasks.css";

const Task = ({
  id,
  title,
  sourceColumnId,
  task,
  onDelete,
  onCloseSalve,
  column,
  // onArchive,
  dragOverIndex,
  taskIndex,
}) => {
  const [openDialog, setOpenDialog] = useState();
  const [messageDialog, setMessageDialog] = useState();
  const [titleDialog, setTitleDialog] = useState();
  const [statusDialog, setStatusDialog] = useState();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detecta se é mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Configura o comportamento de drag da tarefa
  const [{ isDragging }, drag] = useDrag({
    type: "task",
    item: { id, sourceColumnId, index: task.index || 0 },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag: true,
  });

  // Se `id` ou `title` não existirem, retorna nulo
  if (!id || !title) {
    return null;
  }



  const handleCardClick = () => {
    setIsModalVisible(true); // Exibe o modal
  };

  const handleOk = () => {
    setIsModalVisible(false); // Fecha o modal ao clicar em "OK"
  };

  const onClose = () => {
    setIsModalVisible(false); // Fecha o modal ao clicar em "Salvar"
    onCloseSalve();
    // navigate(0);
    // handleReload(true)
  };

  const handleCancel = () => {
    setIsModalVisible(false); // Fecha o modal ao clicar em "Cancelar"
    onCloseSalve();
    // navigate(0);
    // handleReload(true)
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  // Determina se este card deve mostrar feedback visual
  const shouldShowDropIndicator = dragOverIndex !== -1 && dragOverIndex === taskIndex;
  const shouldMoveDown = dragOverIndex !== -1 && dragOverIndex < taskIndex;

  return (
    <div
      ref={drag}
      className={`task-item ${isDragging ? "dragging" : ""} ${
        shouldShowDropIndicator ? "drop-indicator" : ""
      } ${shouldMoveDown ? "move-down" : ""}`}
      style={{
        opacity: isDragging ? 0.5 : 1,
        transform: isDragging ? "rotate(5deg)" : "none",
      }}
    >
      <ResponsiveDialog
        open={openDialog}
        handleClose={handleDialogClose}
        title={titleDialog}
        message={messageDialog}
        status={statusDialog}
      />

      <SmallCard
        title={title}
        subtitle={task.customer.name ? task.customer.name : "Orçamento avulso"}
        panelCount={task.items.length}
        value={task.ticket}
        onClick={handleCardClick}
        onDelete={(e) => {
          onDelete(id);
        }}
        column={column}
        ticketMeddle={task.ticketMeddle}
        isMobile={isMobile}
        dragRef={drag}
        // onArchive={(id) => {
        //   onArchive(id);
        // }}
      />

      <Modal
        title={title}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null} // Remove o rodapé
        centered // Centraliza o modal na tela
        style={{ top: "5vh" }} // Centraliza verticalmente com base na viewport
        styles={{
          body: {
            height: "80vh", // Define a altura como 90% da altura da viewport
            padding: 0,
            margin: 0,
            overflow: "auto", // Permite rolagem se o conteúdo ultrapassar o modal
          },
        }}
        width="90vw" // Define a largura como 90% da largura da viewport
        closable={true} // Remove o botão de fechar
        maskStyle={{
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Altera a opacidade do fundo
        }}
      >
        <div>
          <NewAvailability idbudget={id} onClose={onClose} />
        </div>
      </Modal>
    </div>
  );
};

export default Task;
